export const SURVEYS_LIST = 0;
export const SECTEURS_LIST = 1;
export const MODELES_LIST = 2;
export const ENSEIGNES_LIST = 3;



// WEBPACK FOOTER //
// src/components/Constants.js